import type { z } from 'zod';

import type { LegacyTopicSchema } from './schemas';

type LegacyTopicField = keyof z.infer<typeof LegacyTopicSchema>;

const listAttributes = [
  'id',
  'subject',
  'code',
  'label',
  'topicGroupId',
  'topicGroupCode',
] as const satisfies readonly LegacyTopicField[];

const getAttributes = [
  ...listAttributes,
  'examCodes',
] as const satisfies readonly LegacyTopicField[];

const searchAttributes = ['label'] as const satisfies readonly LegacyTopicField[];

const updateAttributes = ['label'] as const satisfies readonly LegacyTopicField[];

export const LegacyTopicAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
};
